export default __webpack_public_path__ + "static/media/sidebar-4.f4df82f0.jpg";